 <aside id="left-panel">
     <nav>
         <br>
         <div class="profile-image-box">
             <div class="gold" [ngClass]="imageurl=='' || imageurl==undefined?'setnavBackgroundImg':''">
                <img *ngIf="imageurl!='' && imageurl!=undefined" [src]="imageurl ? imageurl:''" alt="profile"  class="body-image profile-pic-image">

             </div>
         </div>
         <div class="text-center"><span class="userlabel">{{userName}}</span></div>
         <div class="text-center mb-4"><span class="company-label" id="help_text" (click)="goToAdmin()" (keydown.enter)="goToAdmin()">{{companyName}}</span></div>
         <ul saSmartMenu>
             <li routerLinkActive="active">
                 <a title="{{'profile_myProfile' | i18n}}" routerLink="/profile">
                     <i class="fas fa-user" style="font-size: 17px !important;"></i>
                     <span class="menu-item-parent pl-3">{{'profile_myProfile' | i18n}}</span></a>
             </li>
         </ul>
     </nav>

     <div class="navFooter">
         <div class="colDisplay">
             <div class="logoutSection">
                 <sa-clearCache></sa-clearCache>
             </div>
         </div>
     </div>
 </aside>